import React from "react";

const CPP_Certificate = () => {
  return (
    <div>
      <h1>CPP_Certificate Component</h1>
      <p>Content for CPP_Certificate goes here...</p>
    </div>
  );
};

export default CPP_Certificate;
